import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class HidService {
  constructor() {}

  setHID(data: string) {
    localStorage.setItem("holdingCode", data);
  }

  setHIDName(data: string) {
    localStorage.setItem("holdingName", data);
  }

  getHID() {
    return localStorage.getItem("holdingCode");
  }

  getHIDName() {
    return localStorage.getItem("holdingName");
  }
}
